<div class="settings-container" [class]="class" [ngClass]="{open:displaySettings}">
    
    <button class="toggle-display-button" (click)="toggleSettings()">
        <!-- <i  class="pi pi-chevron-right" ></i> -->
        <i [class]="iconDirection"> </i>
    </button>

    <!-- English -->
    <div class="row toggle-row" *ngIf="class=='ltr'" [ngClass]="{open:displaySettings}">
        <label>{{roulette?.GeneralDetails?.Name || ('ROULETTE.MYֹ_ROULETTE'|translate)}}</label>
    </div>

    <!-- Hebrew -->
    <div class="row toggle-row" *ngIf="class=='rtl'" [ngClass]="{open:displaySettings, hebrew: class=='rtl'}">
        <label>{{roulette?.GeneralDetails?.Name || ('ROULETTE.MYֹ_ROULETTE'|translate)}}</label>
    </div>

    <p-tabView *ngIf="displaySettings" class="settings-tabs-container" [ngClass]="{hebrew:class=='rtl'}">
        <p-tabPanel header="{{'ROULETTE.DEFINITIONS'|translate}}">
            <app-roulette-general-details [roulette]="roulette" [form]="form"></app-roulette-general-details>
        </p-tabPanel>
        <p-tabPanel header="{{'ROULETTE.STYLE'|translate}}">
            <app-roulette-design-settings [roulette]="roulette" [form]="form"></app-roulette-design-settings>
        </p-tabPanel>
        <p-tabPanel header="{{'ROULETTE.AWARDS'|translate}}">
            <app-roulette-coupons-settings [roulette]="roulette" [form]="form"></app-roulette-coupons-settings>
        </p-tabPanel>
        <p-tabPanel header="{{'ROULETTE.LOGO'|translate}}">
            <app-roulette-logo-settings [roulette]="roulette"></app-roulette-logo-settings>
        </p-tabPanel>
    </p-tabView>

</div>
